import { type Reimbursement } from '@kalos/kalos-rpc';
import { z } from 'zod';

import { type ZodObjectWithModelKeys } from '../../../tools/typeguargs';

// Create form schema and types
type ReimbursementCreateFormFields = Pick<
  Reimbursement,
  'jobNumber' | 'userId' | 'amount' | 'description'
> & { photo: File[] };

export const reimbursementCreateFormSchema = z.object({
  jobNumber: z.number(),
  userId: z.number(),
  amount: z.coerce.number(),
  description: z
    .string()
    .max(255, 'Description is too long (max 255 characters)')
    .min(1, 'Description is required'),
  photo: z.array(z.instanceof(File)).length(1, 'Please upload a photo'),
}) satisfies ZodObjectWithModelKeys<ReimbursementCreateFormFields>;

/** The create form's values, shared with the phone form. */
export type ReimbursementCreateFormValues = z.infer<typeof reimbursementCreateFormSchema>;

// Edit form schema and types
type ReimbursementEditFormFields = Pick<
  Reimbursement,
  'jobNumber' | 'userId' | 'amount' | 'description'
>;

export const reimbursementEditFormSchema = z.object({
  jobNumber: z.number(),
  userId: z.number(),
  amount: z.coerce.number(),
  description: z
    .string()
    .max(255, 'Description is too long (max 255 characters)')
    .min(1, 'Description is required'),
}) satisfies ZodObjectWithModelKeys<ReimbursementEditFormFields>;

/** The edit form's values, shared with the phone form. */
export type ReimbursementEditFormValues = z.infer<typeof reimbursementEditFormSchema>;
